// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// Since 2026-10-23 all RelayMD data lives in the relaymd-api project: the doctor
// collections were moved there from docdir-dashboard. `db` and `apiDB` are the same
// database, and staff sign in with the shared relaymd-api login.
const firebaseConfig = {
  apiKey: 'AIzaSyB25ZYa9WF7gDca34Y_wiw2Nu0tQ_FDoZg',
  authDomain: 'relaymd-api.firebaseapp.com',
  projectId: 'relaymd-api',
  storageBucket: 'relaymd-api.appspot.com',
  messagingSenderId: '492758999293',
  appId: '1:492758999293:web:ff5f76903d870643a85e94',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const apiDB = db;

const logout = () => {
  signOut(auth);
};

export { auth, db, apiDB, signInWithEmailAndPassword, logout };
